import { useEffect } from 'react';

export const useGoogleFontPreload = () => {
  useEffect(() => {
    let fontLink = document.querySelector<HTMLLinkElement>('link#google-sans-font');
    if (!fontLink) {
      fontLink = document.createElement('link');
      fontLink.id = 'google-sans-font';
      fontLink.rel = 'stylesheet';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Google+Sans:wght@500&display=swap';
      document.head.appendChild(fontLink);
    }

    return () => {
      if (fontLink?.id === 'google-sans-font') fontLink.remove();
    };
  }, []);
};
